import React from 'react';
import Modal from '@mui/material/Modal';
import module from './HistoryModal.module.css';
import { Box } from '@mui/material';

function HistoryModal({ isOpen, onClose, status }) {
    const commonMessages = {
        notNewUser: '紹介した方が新規ユーザーではないと判定されました。',
        transferFailed: '振込に失敗しました。',
        judgeCategory: {
            notApplicable: '審査で報酬対象外',
            transferFailed: '振込失敗',
        },
        Annotation: <span className={module.AnnotationText}>※ 本報酬の支払いを一時停止しております。<br />口座情報を再度設定いただいたのち、再度振り込みを実施いたします。</span>,
    };

    const statusMessages = {
        2: {
            judgeCategory: commonMessages.judgeCategory.notApplicable,
            content: (
                <>
                    <p>{commonMessages.notNewUser}</p>
                    <p>住所に以前受け取った履歴があります</p>
                </>
            ),
        },
        3: {
            judgeCategory: commonMessages.judgeCategory.notApplicable,
            content: (
                <>
                    <p>{commonMessages.notNewUser}</p>
                    <p>電話番号に以前受け取った履歴があります</p>
                </>
            ),
        },
        4: {
            judgeCategory: commonMessages.judgeCategory.transferFailed,
            content: (
                <>
                    <p>{commonMessages.transferFailed}</p>
                    <p>銀行口座の登録がありませんでした</p>
                    {commonMessages.Annotation}
                </>
            ),
        },
        5: {
            judgeCategory: commonMessages.judgeCategory.transferFailed,
            content: (
                <>
                    <p>{commonMessages.transferFailed}</p>
                    <p>銀行口座の情報に不備がありました</p>
                    {commonMessages.Annotation}
                </>
            ),
        },
        6: {
            judgeCategory: commonMessages.judgeCategory.transferFailed,
            content: (
                <>
                    <p>{commonMessages.transferFailed}</p>
                    <p>銀行口座の情報に不備がありました</p>
                    {commonMessages.Annotation}
                </>
            ),
        },
    };

    const { judgeCategory, content } = statusMessages[status] || { judgeCategory: '', content: null };

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box className={module.wrapper}>
                <p>以下の理由で{judgeCategory}となりました</p>
                <Box className={module.contentBox}>{content}</Box>
            </Box>
        </Modal>
    );
}

export default HistoryModal;